<div class="log-viewer-control" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div cdkDragHandle class="log-viewer-header">
    <h1 mat-dialog-title class="dialog-header">Log Files</h1>
  </div>
  <div class="log-viewer-content">
    <div class="form-group">
      <mat-form-field>
        <mat-select (selectionChange)="logFileChange($event)" [(value)]="logFileValue">
          <mat-option [value]="0" selected="true">Campaign Boss Log File</mat-option>
          <mat-option [value]="1">Campaign Boss Maintenance Log File</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="actions-row" style="margin-bottom: 8px; display: inline-block; align-content: center;">
        <button mat-raised-button color="warn" (click)="purgeArchived()" [disabled]="isPurging">
          {{ isPurging ? 'Purging...' : 'Purge Archived Logs' }}
        </button>
      </div>
    </div>

    <div class="log-container" #logContainer>
      <pre class="log-content">{{ logs }}</pre>
    </div>
  </div>
  <div class="log-viewer-footer">
    <hr />
    <mat-dialog-actions>
      <div class="button-row">
        <button mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
